module.exports = __webpack_public_path__ + "img/swords_on.e1667d8f.png";